import React from 'react';
import InteractiveTextViewer from './InteractiveTextViewer';
import PropTypes from 'prop-types';

const ShortStoryInteractiveTextViewer = ({ 
    formattedText, 
    textId, 
    style = {},
    onWordDisplayed = null
}) => {
    const shortStoryStyle = {
        lineHeight: 1.8,
        fontSize: '1.1rem',
        fontFamily: 'Georgia, serif',
        textAlign: 'justify',
        ...style
    };

    return (
        <InteractiveTextViewer
            formattedText={formattedText}
            textId={textId}
            baseClassName="short-story-interactive-text"
            style={shortStoryStyle}
            source={{ type: 'short_story', id: textId }}
            onWordDisplayed={onWordDisplayed}
        />
    );
};

ShortStoryInteractiveTextViewer.propTypes = {
    formattedText: PropTypes.string.isRequired,
    textId: PropTypes.string.isRequired,
    style: PropTypes.object,
    onWordDisplayed: PropTypes.func
};

export default ShortStoryInteractiveTextViewer; 